<script lang="ts" setup>
const media = useMedia();

const props = defineProps<{
    pager: Pager;
}>();

const emit = defineEmits<{
    (e: 'change', index: number): void;
}>();

const limit = computed(() => media.phone ? 1 : 5);
const current = computed(() => props.pager.pageIndex);

const before = computed(() =>
{
    if (props.pager.totalRows === Number.MAX_SAFE_INTEGER)
        return [];

    const index = current.value - limit.value;

    return Array(limit.value).fill(undefined).map((p, i) => index + i).filter(p => p > 0);
});

const after = computed(() =>
{
    if (props.pager.totalRows === Number.MAX_SAFE_INTEGER)
        return [];

    const index = current.value + 1;

    return Array(limit.value).fill(undefined).map((p, i) => index + i).filter(p => p <= props.pager.totalPages);
});

const onPaging = (pageIndex: number): void =>
{
    props.pager.setPageIndex(pageIndex);

    emit('change', pageIndex);
};

const first = (): void =>
{
    onPaging(1);
};

const prev = (): void =>
{
    onPaging(props.pager.pageIndex - 1);
};

const page = (index: number): void =>
{
    onPaging(index);
};

const next = (): void =>
{
    onPaging(props.pager.pageIndex + 1);
};

const last = (): void =>
{
    onPaging(props.pager.totalPages);
};
</script>

<template>
    <ul class="pagination justify-content-center mb-0">
        <li class="page-item" :class="{ 'disabled': before.length == 0 }">
            <a class="page-link" href="#" @click.prevent="first()">
                <i :title="$t('[[[Pierwsza strona]]]')" class="far fa-angle-double-left" />
            </a>
        </li>
        <li class="page-item" :class="{ 'disabled': before.length == 0 }">
            <a class="page-link" href="#" @click.prevent="prev()">
                <i :title="$t('[[[Poprzednia strona]]]')" class="far fa-angle-left" />
            </a>
        </li>
        <li v-for="n in before" :key="n" class="page-item">
            <a class="page-link" href="#" @click.prevent="page(n)">{{ n }}</a>
        </li>
        <li class="page-item active">
            <span class="page-link">{{ current }}</span>
        </li>
        <li v-for="n in after" :key="n" class="page-item">
            <a class="page-link" href="#" @click.prevent="page(n)">{{ n }}</a>
        </li>
        <li class="page-item" :class="{ 'disabled': after.length == 0 }">
            <a class="page-link" href="#" @click.prevent="next()">
                <i :title="$t('[[[Następna strona]]]')" class="far fa-angle-right" />
            </a>
        </li>
        <li class="page-item" :class="{ 'disabled': after.length == 0 }">
            <a class="page-link" href="#" @click.prevent="last()">
                <i :title="$t('[[[Ostatnia strona]]]')" class="far fa-angle-double-right" />
            </a>
        </li>
    </ul>
</template>
